import { useTranslations } from "@shared/context/useTranslations";
import { IconNames } from "@shared/enums/icons.enums";
import { SvgIcon } from "@shared/components/Atoms/SvgIcon/SvgIcon";
import S from "./FreightDocumentLink.module.scss";

interface FreightDocumentLinkProps {
    url: string | null;
}

export const FreightDocumentLink = ({ url }: FreightDocumentLinkProps) => {
    const { getTranslation } = useTranslations();

    if (!url) {
        return null;
    }

    return (
        <div className={S.freightBox}>
            <a href={url} target="_blank" rel="noopener noreferrer" className={S.freightLink}>
                <SvgIcon iconName={IconNames.Pdf} className={S.freightPdfIcon} />
                {getTranslation("general.freightCost.linkText")}
            </a>
        </div>
    );
};
